class Section {

  constructor(calculator) {
    this.calculator = calculator
    this.form = calculator.form
    this.parts = []
    this.section = this.processSection()
    this.accordion();

    this.fee = 0;
  }

  format(cost) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
    }).format(cost)
  }

  processSection() {
    let section = this.form.find('.catcalc-section-' + this.constructor.name.toLowerCase())

    return section
  }

  accordion() {
    let container = $('<div class="m_section"></div>')
    let parts = this.section.nextUntil('.gsection')

    container.insertAfter(this.section)
    container.append(parts)

    this.section.on('click touch', function() {
      $(this).next('.m_section').slideDown()
    })
  }

  fees() {
    // 20% service fee for all food and beverage
    return .2 * this.subtotal();
  }

  total() {
    return this.subtotal() + this.fees();
  }

  subtotal() {
    return this.parts.reduce(((accumulator, part) =>  accumulator + part.total()),0)
  }


}

export default Section



// WEBPACK FOOTER //
// ./scripts/catcalc/section.js